var map = {
	"./": 141,
	"./Clutch": 2670,
	"./Clutch.js": 2670,
	"./NewUi": 2671,
	"./NewUi.js": 2671,
	"./OldUi": 2672,
	"./OldUi.js": 2672,
	"./index": 141,
	"./index.js": 141,
	"./style": 861,
	"./style.js": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4196;